import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import tagihanBiayaService from "../../services/tagihanBiayaService";
import Cookies from "js-cookie";

export const initialState = {
    loading_tagihan_biaya: false,
    data_tagihan_biaya: [],
    showMessage:false,
    message:'',
}


export const getDataTagihanBiaya = createAsyncThunk('tagihan_biaya/data',async (data, { rejectWithValue }) => {
    try {
        const response = await tagihanBiayaService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const tagihanBiayaSlice = createSlice({
    name: 'tagihan_biaya',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_tagihan_biaya = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataTagihanBiaya.fulfilled, (state, action) => {
                state.loading_tagihan_biaya = false
                state.data_tagihan_biaya = action.payload??[]
            })
            .addCase(getDataTagihanBiaya.pending, (state) => {
                state.loading_tagihan_biaya = true
            })
            .addCase(getDataTagihanBiaya.rejected, (state, action) => {
                state.loading_tagihan_biaya = false
                state.data_tagihan_biaya = action.payload
            })
    },
})

export const {
    showLoading,
} = tagihanBiayaSlice.actions

export default tagihanBiayaSlice.reducer
